<script setup lang="ts">
defineProps<{ title: string }>();
const { isDesktop } = useResponsive();
const { params, shop, isLoading, status, error } = useShop();
async function onUpdatePage() {
  await nextTick();
  document.getElementById("shop")?.scrollIntoView({ behavior: "smooth" });
}
</script>

<template>
  <section id="shop" class="container flex flex-col gap-x-8 gap-y-4 py-8 lg:flex-row">
    <ShopFilters v-if="isDesktop" class="w-72 shrink-0" />
    <div class="isolate flex-1 space-y-8">
      <div class="relative z-sticky flex flex-col flex-wrap gap-x-4 gap-y-2 lg:flex-row lg:items-center">
        <h1 class="mr-auto text-3xl font-bold text-primary lg:w-full xl:w-auto">
          {{ title }}
        </h1>
        <ShopFiltersToggler v-if="!isDesktop" />
        <ShopCount class="mobile:order-last mobile:self-end" />
        <ShopPerPage />
        <ShopSorting />
      </div>
      <UiQueryWrapper :is-loading="isLoading" :status="status" :error="error">
        <ProductGrid :products="shop.products" />
      </UiQueryWrapper>
      <UiPagination v-model:page="params.page" :items-per-page="params.per_page" :total="shop.products_total" @update:page="onUpdatePage" />
    </div>
  </section>
</template>
